/**
 * Client-side Axios failures that are not actionable app bugs.
 * Keep in sync with CRM `isNoiseAxiosError` (CU-86d3vb6hq), plus Book-specific
 * expected tenant-resolution 404s (MOVEPRO-BOOK-AC).
 *
 */
export function isNoiseAxiosError(error: unknown): boolean {
    const e = error as any;

    if (e?.code === 'ERR_CANCELED' || e?.code === 'ERR_NETWORK' || e?.message === 'Network Error') {
        return true;
    }

    // Path/host tenancy miss: API returns 404 {"message":"Tenant not found."}
    // before any customer route runs. Expected on typos / reserved subdomains.
    if (
        e?.response?.status === 404 &&
        typeof e?.response?.data?.message === 'string' &&
        e.response.data.message.startsWith('Tenant not found')
    ) {
        return true;
    }

    return false;
}
